import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import CookieConsent from '../ui/CookieConsent';
import CallbackButton from '../ui/CallbackButton';
import { Breadcrumbs } from '../Breadcrumbs';
import Hero from '../home/Hero';

const Layout: React.FC = () => {
  const location = useLocation();
  const isCatalogPage = location.pathname.startsWith('/catalog');
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {isHomePage && !isCatalogPage && <Hero />}
      <main className="container mx-auto px-4 py-4">
        {!isHomePage && <Breadcrumbs />}
        <Outlet />
      </main>
      <Footer />
      <CallbackButton />
      <CookieConsent />
    </div>
  );
};

export default Layout;